export const deleteSharedLessonsService = (fetchData) => async () => {
  try {
    const response = await fetchData({
      method: "delete",
      url: `/api/v1/siniestros-viales/documentos/divulgacion-lecciones-aprendidas`,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
